// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__1sBkN","paramInput":"JobSimulator_paramInput__11gmS","input":"JobSimulator_input__1Ndqj"};